import { render } from "./modifyUserCard.vue?vue&type=template&id=dbbb4784&scoped=true"
import script from "./modifyUserCard.vue?vue&type=script&lang=js"
export * from "./modifyUserCard.vue?vue&type=script&lang=js"

import "./modifyUserCard.vue?vue&type=style&index=0&id=dbbb4784&lang=scss"
import "./modifyUserCard.vue?vue&type=style&index=1&id=dbbb4784&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbb4784"]])

export default __exports__